/**
 * This patch adds missing filters to dynamic links of mode "email" or "phone"
 */

import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;

  const data = jsonNode.data;
  const linkData = data && data.link;
  const isEmailLink = linkData && linkData.mode === 'email';
  const isPhoneLink = linkData && linkData.mode === 'tel';
  const hrefBinding = data && data.dyn && data.dyn.bind && data.dyn.bind.href;
  const nonEmptyBinding = Array.isArray(hrefBinding) && hrefBinding.length > 0;
  const lastFragment = nonEmptyBinding && hrefBinding[hrefBinding.length - 1];
  const patchNeeded =
    (isEmailLink || isPhoneLink) && lastFragment && !lastFragment.filter;

  return {
    needed: patchNeeded,
    logData: {
      msg: 'Email or Phone link binding without correct filter',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      if (isEmailLink) {
        let subject = linkData.subject;
        if (subject) {
          try {
            subject = encodeURIComponent(subject);
          } catch (ex: any) {
            console.log('ERROR ENCODING URI: ' + ex.message);
          }
        }
        const subjectString = subject ? '|' + subject : '';
        // To make flow happy. This is already checked for `patchNeeded`.
        if (lastFragment) {
          lastFragment.filter = 'email|href' + subjectString;
        }
      } else if (isPhoneLink) {
        // To make flow happy. This is already checked for `patchNeeded`.
        if (lastFragment) {
          lastFragment.filter = 'phone|href';
        }
      }
    },
  };
};
